import React from "react"

import { FormattedMessage } from "react-intl"

const Colon = () => <FormattedMessage id={":"} />

export default Colon
